import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import { Season, Match, MatchSource, PlayerSource, Team } from '../../models'
import '@scoutgg/ftw/source/atoms/select/select'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import template from './edit-match-source.jade'
import customFields from '../../../helpers/match-custom-fields'

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('match', Match)
@Attribute('free-mode', Boolean)
@Attribute('isSubMatch', Boolean)
export default class EditMatchSource extends HTMLElement {
  attached() {
    const { season, match } = this
    if(match && !match.season) match.season = season
    this.editedTeams = match?.teams || []
    this.sport = season?.sport
    if(this.sport === 'tennis' && match._id === '-1') match.matchType = 'set3'
    this.selectedPositions = this.matchPosition
    this.update(PlayerSource.load({ season: season._id, $reload: true }))
    this.render()
  }

  editTeam(match, attr, e) {
    if(/customDifficultyHome/.test(attr)) {
      if(!match.customDifficulty) match.customDifficulty = [0, 0]
      match.customDifficulty[0] = parseInt(e.target.value)
    } else if(/customDifficultyAway/.test(attr)) {
      if(!match.customDifficulty) match.customDifficulty = [0, 0]
      match.customDifficulty[1] = parseInt(e.target.value)
    } else if(['score1', 'score2'].includes(attr)) {
      let index = attr === 'score1' ? 0 : 1
      if(!match.score) match.score = [0, 0]
      match.score[index] = e.target ? e.target.value : e
    } else {
      match[attr] = e.target ? e.target.value : e
    }
  }

  changeTeam(team, index) {
    this.editedTeams[index] = Team.instance(team)
    this.render()
  }

  addTeam(team) {
    this.editedTeams.push(Team.instance(team))
    if(team === 'all') this.editedTeams = this.sortedTeams
    this.render()
  }

  removeTeam(team) {
    this.editedTeams = this.editedTeams
      .filter(t => t !== team)
    this.render()
  }

  async closeModal() {
    const params = {
      match: this.match,
      teams: this.editedTeams,
    }
    if(this.match._id < 0) { // N
      params.match = await this.createMatch(params)
    } else {
      params.source = await this.saveMatch(params)
    }
    this.parentNode.close(params)
  }

  async createMatch({ match, teams }) {
    if(match.isEsports) {
      if(!match.locations) {
        let maps = []
        for(let x = 1; x < 6; x++) {
          maps.push({
            mapNumber: x,
          })
        }
        match.locations = (maps || []).map(map => {
          return {
            map: {
              name: 'Standard Map ' + map.mapNumber,
              uid: match.id || null,
            },
          }
        })
      }
    }

    return MatchSource.post('', {
      season: this.season._id,
      custom: [{
        ...match.toJSON(),
        new: true,
        teamOverrides: teams.map(t => t._id),
      }],
    }).then(response => {
      return Match.create(response[0])
    })
    .catch(err => {
      notify(err.message, {level: 'danger', timeout: 10000})
      console.error(err)
    }).then(() => this.render())
  }

  async saveMatch({ match, teams }) {
    let customSource = this.seasonSources[0]?.source
    // Nobody working here knows why it's done like this
    const directSources = [
      'steamAPI',
      'fdGolf',
    ]
    var params = {
      source: [
        'steamAPI',
        'fdGolf',
      ].includes(customSource)
        ? customSource : 'custom',
      priority: 0,
      match,
    }
    // Nobody knows why this is slightly different
    if(['abiosCsgo', 'fdGolf'].includes(customSource)) {
      let { uid } = match.matchSources.find(s => s.uid) || { uid: match.uid }
      if(uid) Object.assign(params, { uid, seasonSource: this.seasonSources[0] })
    }
    const source = {
      ...match.toJSON(),
      ...MatchSource.create(params),
    }
    await MatchSource.post('', {
      season: match.season._id,
      custom: [{
        match: match._id,
        ...source,
        teamOverrides: teams.map(t => t._id),
      }],
    })
    return source
  }

  matchDate(match, format, time) {
    if(match.startTime && time === 'start') return this.moment(match.startTime).format(format)
    if(match.endTime && time === 'end') return this.moment(match.endTime).format(format)
    return ''
  }

  addPosition(position) {
    if(!this.selectedPositions) this.selectedPositions = []
    this.selectedPositions.push(position)
    this.match.positions = this.selectedPositions
    this.render()
  }

  toggleSubMatch(e) {
    this.match.isSubMatch = this.match.isSubMatch ? false : true
  }
  toggleSingleRound(e) {
    this.match.isSingleRound = this.match.isSingleRound ? false : true
  }
  removePosition(position) {
    this.selectedPositions = this.selectedPositions.filter(z => z !== position)
    this.match.positions = this.selectedPositions
    if(!this.selectedPositions.length) delete this.match.positions
    this.render()
  }

  get customFields() {
    return customFields(this.season?.rules)
  }

  get similarTeams() {
    if(this.editedTeams && (this.editedTeams[0] === this.editedTeams[1])) return false
    return true
  }

  get sortedTeams() {
    return (this.teams || [])
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      .filter(a => !a.notAvailable)
  }

  get matchTeams() {
    if(this.match._id === '-1') return [0, 1]
    if(this.match.awayTeam === undefined) this.match.teams = this.match.teams.concat([1])
    if(this.match.homeTeam === undefined) this.match.teams = this.match.teams.concat([0])
    return this.match.teams
  }

  get positions() {
    return this.match?.rulePositions
  }

  get uid() {
    if(this.match.matchSources?.length) {
      return this.match.matchSources.sort(
        (a, b) => (a.priority - b.priority) || ((a.uid ? 1 : 0) - (b.uid ? 1 : 0)))[0].uid
    } else {
      return ''
    }
  }

  get matchPosition() {
    return this.match.positions
  }
}
